import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';
import { environment } from '../../env/environment';
import { CertificateService } from '../certificate-auth/certificate.service';
import { EcsService } from '../ecs/ecs.service';
import User from '../user-auth/User';
import { IIamDecodedToken, IUserAccounts } from './user-auth-iam.model';


@Injectable({
    providedIn: 'root'
})
export class UserAuthIamService {
    public registration: any;
    public dadosME : BehaviorSubject<boolean>;
    // public userData = new BehaviorSubject(this.registration);
    public userData:  BehaviorSubject<any>;
    // public currentUserData = this.userData.asObservable();
    public currentUserData: any;
    private jwtHelper = new JwtHelperService();
    private serasaTokenName = 'Serasa-Cp-AU';
    private accessTokenName = 'accessTokenJWT';


    constructor(private http: HttpClient,
        private cookieService: CookieService,
        private certificateService: CertificateService,
        private ecsService: EcsService) {

    this.userData = new BehaviorSubject(this.registration);
    this.currentUserData = this.userData.asObservable();


        this.dadosME = new BehaviorSubject<boolean>(false)
        const cookieToken = this.cookieService.get(this.serasaTokenName);
        const isValidCookieToken = this.isValid(cookieToken);

        if (isValidCookieToken) {
            this.accessTokenJWT = cookieToken;
        }

        // if (!environment.production) {
        //     /* [DEVELOPMENT ONLY] */
        //     if (features.enableAuthIam && !this.isValidAccessToken) {
        //         this.accessTokenJWT = window.prompt(this.accessTokenName) || '';
        //     }
        // }
    }

    //     public recoverToken() {
    //         return new Observable(observer => {
    //             this.getClientIdentity().subscribe(
    //                 response => {
    //                     this.authEcsByCookie(response.accessToken).subscribe(
    //                         newCredential => {
    //                             this.accessTokenJWT = newCredential.accessToken;
    //                             observer.next(newCredential);
    //                         },
    //                         err => {
    //                             setTimeout(() => {
    //                                 observer.error(err);
    //                             }, 3000);
    //                         }
    //                     );
    //                 },
    //                 error => {
    //                     observer.error(error);
    //                 }
    //             );
    //         });
    //     }

    //     private getClientIdentity() {
    //         return this.http.post<IClientIdentity>(`${environment.certificateBasePath}/client-identities/login`, null, {
    //             headers: new HttpHeaders({
    //                 'Content-Type': 'application/json',
    //                 Authorization: `Basic ${clientId.tokenApp}`
    //             })
    //         });
    //     }

    //     private authEcsByCookie(accessToken) {
    //         return this.http.post<IClientIdentity>(
    //             `${environment.certificateBasePath}/user-identities/auth-ecs-by-cookie`,
    //             { token: this.cookieService.get('Valgrind-AU') },
    //             {
    //                 headers: new HttpHeaders({
    //                     'Content-Type': 'application/json',
    //                     Authorization: `Bearer ${accessToken}`
    //                 })
    //             }
    //         );
    //     }

    //     public getData(registration: any) {
    //         this.userData.next(registration);
    //     }

    public accountData() {
        return this.http
            .get<any>(`${environment.accountBasePath}/user-accounts/me`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.accessTokenJWT}`
                })
            })
            .pipe(flatMap(((data: IUserAccounts) => this.getEcsInformation2(data)
            )),
                catchError(error => {
                    throw error;
                }));
    }

    private getEcsInformation(user: User) {
        return this.ecsService.getEcsInformation().pipe(map((ecs: User) => {
            if (ecs) {
                user.email = ecs.email ? ecs.email : user.email;
                user.phone = ecs.phone ? ecs.phone : user.phone;
                return user;
            }
        }))
    }

    private getEcsInformation2(data: IUserAccounts) {
        var user = new User({
            id: data.id,
            name: data.fullName,
            fullName: data.fullName,
            document: data.document.documentId,
            phone: User.formatPhone(data.mobile),
            email: data.email.email,
            birthdate: data.birthDate,
            picture: data.userEcs ? data.userEcs.picture : ''
        });
        if(this.checkIfCertificate()){
            return this.ecsService.getEcsInformation().pipe(map((ecs: User) => {
                if (ecs) {
                    user.email = ecs.email ? ecs.email : user.email;
                    user.phone = ecs.phone ? ecs.phone : user.phone;
                }
                return user;
            }))
        }
        return of(user);
    }

    private checkIfCertificate() {
        return jwt_decode(sessionStorage.getItem('accessTokenJWT')).authorities.includes("ROLE_AUTH-STRONG");
    }

    //     get personValidated() {
    //         return this.hasRole(IamAuthorities.ROLE_PERSON_VALIDATED);
    //     }

    //     get isAuthStrong() {
    //         return this.hasRole(IamAuthorities.ROLE_AUTH_STRONG);
    //     }

    //     get accessTokenJWT(): string {
    //         const localToken = localStorage.getItem(this.accessTokenName);
    //         const certificateToken = this.certificateService.getCertificateToken();
    //         const isValidCertificate = !!certificateToken && this.isValid(certificateToken);

    //         if (certificateToken) {
    //             if (isValidCertificate) {
    //                 return certificateToken;
    //             }

    //             this.certificateService.clearCertificate();
    //         }

    //         return localToken;
    //     }

    set accessTokenJWT(token) {
        localStorage.setItem(this.accessTokenName, token);
    }

    public hasRole(role: string): boolean {
        const decoded = this.decodedToken;

        if (decoded) {
            return decoded.authorities.indexOf(role) > -1;
        }

        return false;
    }

    public get isValidAccessToken() {
        return this.isValid(this.accessTokenJWT);
    }

    public isValid(token): boolean {
        if (!token) {
            return false;
        }

        try {
            return !this.jwtHelper.isTokenExpired(token);
        } catch (error) {
            return false;
        }
    }

    get decodedToken(): IIamDecodedToken | null {
        const token = this.accessTokenJWT;

        if (!token) {
            return null;
        }

        return this.jwtHelper.decodeToken(token);
    }

    get expirationDate() {
        const token = this.accessTokenJWT;

        if (!token) {
            return null;
        }

        return this.jwtHelper.getTokenExpirationDate(token);
    }
}
